<template>
  <div>
    <!-- <v-container fluid class="lighten-12 container"> -->
    <v-row>
      <v-col cols="12 py-0">
        <v-card class="productdetailscard">
          <v-card-title class="mt-0 py-0"> Supplier </v-card-title>
          <v-container fluid>
            <v-row class="ma-0 align-right">
              <!-- <TableFilters
                :filters="['search']"
                v-model="filter"
                :columns="columns"
              ></TableFilters> -->
              <v-col cols="12" sm="12" lg="8" md="12" class="px-0 pt-1 d-flex">
                <v-combobox
                  hide-details="auto"
                  hide-no-data
                  v-model="selectedSupplier"
                  @change="searchSuppliers = ''"
                  @input="GetSuppliers(searchSuppliers)"
                  :items="suppliers"
                  clearable
                  :search-input.sync="searchSuppliers"
                  outlined
                  item-text="name"
                  item-value="id"
                  label="Select Suppliers"
                  multiple
                  small-chips
                >
                </v-combobox>
                <v-btn
                  depressed
                  small
                  height="32"
                  class="btn_blue w-100 ml-2"
                  :disabled="!selectedSupplier || selectedSupplier.length === 0"
                  @click="AssignSupplierToProduct()"
                >
                  update
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                <v-row
                  class="pt-0"
                  v-for="items in ProductSuppliers"
                  :key="items"
                >
                  <v-col
                    cols="8"
                    sm="12"
                    md="8"
                    lg="8"
                    class="pr-5pt-1.5 pb-1 suppliertext"
                  >
                    {{ items.name }}
                    <v-tooltip top color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          small
                          @mouseenter="supplierDetails(items)"
                          >mdi-alert-circle</v-icon
                        >
                      </template>
                      <h5>{{ refnumber }}</h5>
                    </v-tooltip>
                  </v-col>

                  <v-col
                    cols="3"
                    sm="12"
                    md="3"
                    lg="3"
                    style="text-align: left"
                  >
                    <v-chip
                      :color="getStatusColor(items.status)"
                      label
                      style="
                        color: white;
                        font-variant-caps: all-small-caps;
                        font-weight: bold;
                      "
                    >
                      {{ items.is_active == true ? 'Active' : 'Archieve' }}
                    </v-chip></v-col
                  >
                  <v-col
                    cols="1"
                    sm="12"
                    md="1"
                    lg="1"
                    class="pr-3 pt-1.5 pb-2"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          small
                          color="red"
                          class="mr-2 pb-0"
                          @click="openConfirmation(items)"
                        >
                          mdi-archive
                        </v-icon>
                      </template>
                      <span>Remove</span>
                    </v-tooltip>
                  </v-col>
                </v-row>

                <!-- <v-data-table
                  :items-per-page="paginationOptions.perPage"
                  :headers="columns"
                  :items="ProdctShopsData"
                  item-key="id"
                  hide-default-footer
                >

                  <template v-slot:item.no>
                    <v-icon>mdi-vuetify</v-icon>
                  </template>


                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :x-small="true"
                      class="ma-2"
                      label
                      text-color="white"
                      :color="getStatusColor(item.is_active)"
                      dark
                      >{{ item.is_active == true ? "Active" : "Archieve" }}
                    </v-chip>
                  </template>

               
                  <template v-slot:item.action="{ item }">
                    <span>
                      <v-icon
                        v-bind="$attrs"
                        v-on="on"
                        @click="openConfirmation(item)"
                        >mdi-archive</v-icon
                      >
                    </span>
                  </template>
                </v-data-table> -->

                <!-- <v-data-table
                  :items-per-page="paginationOptions.perPage"
                  :headers="columns"
                  :items="ProductSuppliers"
                  item-key="id"
                  hide-default-footer
                >
                  <template v-slot:item.no>
                    <v-icon>mdi-vuetify</v-icon>
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :x-small="true"
                      class="ma-2"
                      label
                      text-color="white"
                      :color="getStatusColor(item.status)"
                      dark
                      >{{ item.status }}
                    </v-chip>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-menu offset-y transition="scroll-y-transition">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon v-bind="attrs" v-on="on"
                          >mdi-dots-vertical
                        </v-icon>
                      </template>
                      <v-list class="actions">
                        <v-list-item @click="openConfirmation(item)">
                          <span>
                            <v-icon v-bind="attrs" v-on="on">mdi-archive</v-icon
                            >Remove
                          </span>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table> -->
                <paginationComponent
                  @paginationOptions="setPaginationOptions"
                  :url="`${module}/${$route.params.id}/suppliers`"
                  @response="receiveSuppliersResponse"
                  :paginationAction="false"
                  ref="supplierdetails"
                  :filter="filter"
                />
              </v-col>
            </v-row>
            <!-- Data table -->

            <v-row> </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <!-- </v-container> -->
  </div>
</template>
<script>
import _ from 'lodash';
import { SupplierListViewModel } from '@/models/View Models/Supplier';
import confirmation from '../../shared/components/confirmation';
import TableFilters from '@/components/base/TableFilters';
import paginationComponent from '../../shared/components/pagination.vue';
import { ProductViewModel } from '../../../models/View Models/ProductViewModel';
export default {
  data: () => ({
    paginationOptions: {},
    searchSuppliers: null,
    selectedSupplier: [],
    suppliers: [],
    refnumber: '',
    columns: [
      {
        text: 'Reference no',
        value: 'reference_number',
        show: true,
        disabled: true,
        align: 'center',
        width: '33%',
      },
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: false,
        align: 'center',
        width: '33%',
      },

      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
        width: '33%',
      },
    ],
    filter: {
      search: '',
      reference_number: '',
      start: '',
      end: '',
      status: '',

      supplier: '',
    },
    date_range: [],
    ProductSuppliers: [],
    productDetails: [],
  }),
  props: {
    module: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  components: { paginationComponent, TableFilters },
  created() {},
  computed: {
    dateRangeText() {
      this.filter.start = this.date_range[0];
      this.filter.end = this.date_range[1];
      return this.date_range.join(' ~ ');
    },
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  watch: {
    searchPurchaseTabSuppliers(value) {
      if (!value) {
        return;
      }
      this.GetPurchaseTabSuppliers(value);
    },
    searchSuppliers(value) {
      if (!value) {
        return;
      }
      this.GetSuppliers(value);
    },
  },

  methods: {
    supplierDetails(item) {
      this.refnumber = item.reference_number;
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.supplierdetails.refreshData();
    },
    async AssignSupplierToProduct() {
      let credentials = new Object();
      credentials.suppliers = [];
      this.selectedSupplier.map((p) => {
        credentials.suppliers.push(p.id);
      });
      credentials.productId = this.$route.params.id;
      this.AssignProduct(credentials);
    },
    AssignProduct(credentials) {
      this.$store
        .dispatch(`product/AssignSupplierToProducts`, credentials)
        .then((res) => {
          this.refreshData();
          this.selectedSupplier = null;
          this.isLoading = false;
          this.$toast.success('Supplier assigned successfully');

          //   this.$refs.supplierdetails[0].refreshData();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toast.error('Failed to assign supplier.');

          this.payment = new Payment();
        });
    },
    openConfirmation(item) {
      confirmation.dialog = true;

      this.$confirm('Do you want to Remove ?').then((res) => {
        if (res) {
          this.removeSupplier(item);
        }
      });
    },
    async removeSupplier(item) {
      const credentials = new Object();
      credentials.suppliers = [item.id];
      credentials.productId = this.$route.params.id;

      this.removeSupplierFromProduct(credentials);
    },

    removeSupplierFromProduct(credentials) {
      this.$store
        .dispatch(`product/RemoveSupplierFromProduct`, credentials)
        .then((res) => {
          this.refreshData();

          let index = this.ProductSuppliers.findIndex(
            (p) => p.id == credentials.suppliers[0],
          );
          if (index != -1) {
            this.ProductSuppliers.splice(index, 1);
          }
          this.selectedSupplier = [];
          this.GetSuppliers();

          this.isLoading = false;
          this.$toast.success('Supplier removed successfully');
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toast.error('Failed to remove supplier.');
          this.payment = new Payment();
        });
    },
    GetProductDetails() {
      let productId = this.id;
      this.$store
        .dispatch('product/GetProductById', productId)
        .then((res) => {
          this.Product = res.data;
          this.productDetails = new ProductViewModel(res.data);
          // this.productDetails.suppliers.forEach((supplier) => {
          //   this.selectedSupplier.push(supplier.id);
          // });
          this.productUnits = this.productDetails.units;
        })
        .catch((err) => {
          this.messages.push(err.data.title);
        });
    },
    getStatusColor(status) {
      return status == true ? 'gray' : 'green';
    },
    receiveSuppliersResponse(supplierData) {
      this.ProductSuppliers = supplierData;
      this.GetSuppliers();
    },

    GetSuppliers(query = '') {
      this.searchSuppliers = null;
      let except = [];
      this.ProductSuppliers.forEach((supplier) => {
        except.push(supplier.id);
      });
      if (this.selectedSupplier?.length > 0) {
        this.selectedSupplier.forEach((supplier) => {
          except.push(supplier.id);
        });
      }
      this.$store
        .dispatch('supplier/GetSupplierSearch', {
          query: query,
          except: except,
          status: 'active',
        })
        .then((res) => {
          this.suppliers = res;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
  },
};
</script>
<style scoped>
.productdetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.suppliertext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: left;

  color: #000000;
}
</style>
